import { render } from "./Packing.vue?vue&type=template&id=b7f361e0&scoped=true"
import script from "./Packing.vue?vue&type=script&lang=js"
export * from "./Packing.vue?vue&type=script&lang=js"

import "./Packing.vue?vue&type=style&index=0&id=b7f361e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f361e0"]])

export default __exports__